export default __webpack_public_path__ + "vision-external-camera-thumbnail-960-c0bde7f675c344047e03d50a620ce55b.webp";